export const OPINION_NAMES = [ 'szalai-barbi', /* 'jezsek-klaudia', */ 'megyeri-klara', 'poti-kriszti', 'pasztor-marina' ] as const
export type TName = typeof OPINION_NAMES[number]

export enum ERouterEvent {
  ContentChanged = 'Router:ContentChanged'
}
